// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2fmyK","file":"styles_file__13on5"};